import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import {
	faGripDotsVertical,
	faTrash,
} from '@fortawesome/pro-regular-svg-icons';
import { Badge, cn, Icon } from '@uturn/ui-kit';
import React, { createContext, type PropsWithChildren } from 'react';

const DraggableContext = createContext(null);

export type Draggable = React.HtmlHTMLAttributes<HTMLDivElement> &
	PropsWithChildren;

const DraggableRoot: React.FC<Draggable> = ({
	children,
	className,
	...props
}) => (
	<DraggableContext.Provider value={null}>
		<div {...props} className={cn(className, 'group')}>
			{children}
		</div>
	</DraggableContext.Provider>
);

const DraggableTitle: React.FC<PropsWithChildren> = ({ children }) => {
	return <h3 className="cursor-text">{children}</h3>;
};

const DraggableInfo: React.FC<PropsWithChildren> = ({ children }) => {
	return <span className="text-gray-500 text-sm">{children}</span>;
};

type DraggableHandleProps = SyntheticListenerMap &
	React.ButtonHTMLAttributes<HTMLButtonElement>;
const DraggableHandle: React.FC<DraggableHandleProps> = ({
	className,
	...props
}) => {
	return (
		<button
			{...props}
			className={cn(className, 'hover:bg-gray-200 rounded-sm')}
		>
			<Icon icon={faGripDotsVertical} size="lg" />
		</button>
	);
};

const DraggableTrash: React.FC<
	React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ className, ...props }) => {
	return (
		<button
			className={cn(
				className,
				'hover:bg-red-200 p-1 flex rounded-sm opacity-0 group-hover:opacity-100',
			)}
			{...props}
		>
			<Icon icon={faTrash} className="text-red-600 size-[16px]" />
		</button>
	);
};

const DraggableBadge: React.FC<PropsWithChildren> = ({ children }) => {
	return <Badge variant="outline">{children}</Badge>;
};

// Compose
export const Draggable = Object.assign(DraggableRoot, {
	Title: DraggableTitle,
	Info: DraggableInfo,
	Handle: DraggableHandle,
	Trash: DraggableTrash,
	Badge: DraggableBadge,
});
